import script from "./Messages.vue?vue&type=script&setup=true&lang=js"
export * from "./Messages.vue?vue&type=script&setup=true&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=399a7030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-399a7030"]])

export default __exports__